import { storageService } from "@trueskin-web/services"

const compareValues = (value1, value2) => {
  if (Array.isArray(value1)) {
    return value1.some((v) => String(v) === String(value2))
  }

  return String(value1) === String(value2)
}

const VisibilityGuard = ({ testName, showVariants, children }) => {
  const lsTestVariant = storageService.getItem({ id: testName }) ?? null

  if (compareValues(showVariants, lsTestVariant)) {
    return children
  }

  return null
}

export default VisibilityGuard
